export default "__VITE_ASSET__XlG0mw$a__"